<div class="toasts">
  <div
    *ngFor="let toast of toasts; let i = index"
    class="flex align-items-center margin-xxl--bottom-10 border-radius background-white border-box padding-xxl--left-18 padding-xxl--right-20 toaster toaster-{{
      toast.type.toLowerCase()
    }}"
    [ngClass]="{ 'cursor-pointer': !!toast.link }"
    (click)="onToastClick(toast)"
  >
    <img src="/assets/images/icons/{{ toast.type.toLowerCase() }}.svg" alt="" />
    <p class="margin-xxl--left-16 font--xxl-14 break-word padding-xxl--right-12 color-black line-height-1_57">
      <b class="font--xxl-14 color-black">{{ toast.type }}: </b> {{ toast.title }}
    </p>
    <img
      class="margin-xxl--left-auto cursor-pointer"
      *ngIf="!toast.isStatusToast"
      (click)="closeToast(i)"
      src="/assets/images/icons/x.svg"
      alt=""
    />
  </div>
</div>
